import React from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { useEntity } from '../../contexts/EntityContext';
import DashboardComponent from '../../components/visualizadorGeral/DashboardComponent';

const DashboardPage: React.FC = () => {
    const history = useHistory();
    const { currentEntity } = useEntity();

    // Check if both entity and year are selected
    if (!currentEntity) {
        return (
            <div className="dashboard-page">
                <Alert variant="warning" className="mt-4">
                    <Alert.Heading>Atenção</Alert.Heading>
                    <p>
                        Para acessar o Visualizador Geral, você precisa selecionar uma entidade e um ano primeiro.
                    </p>
                    <hr />
                    <div className="d-flex justify-content-end">
                        <Button
                            variant="primary"
                            onClick={() => history.push('/home')}
                        >
                            Voltar para Seleção
                        </Button>
                    </div>
                </Alert>
            </div>
        );
    }

    return (
        <div className="dashboard-page">
            <DashboardComponent />
        </div>
    );
};

export default DashboardPage; 